import { useState } from "react"
import useLocalStorage from "../UseLocalStorage"
import { Card, CardBody, CardFooter, Input, Button, Typography, Dialog, Spinner } from "../../lib/mt-native"
 
export default function CaptureForm({open, handleOpen, downloadItems}) {

  // Get the value from local storage if it exists
  const [email, setEmail] = useLocalStorage("downloadedEmail", "")
  const [name, setName] = useLocalStorage("downloadedName", "")

  // Set the value received from the local storage to a local state
  const [downloadedEmail, setDownloadedEmail] = useState(email)
  const [downloadedName, setDownloadedName] = useState(name)
  const [isProcessing, setIsProcessing] = useState(false)

  const encode = (data) => {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
  }
  const downloadItemsString = Object.values(downloadItems.selected).map(item => item.sku).join(', ');

  // When user submits the form, save the favorite number to the local storage
  const saveToLocalStorage = async (e) => {
    e.preventDefault();
    setIsProcessing(true);

    try {
      // Send to email API
      const response = await fetch('/api/capture', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          firstName: downloadedName,
          email: downloadedEmail,
          subject: 'New Download User',
          message: `A new download request was submitted by ${downloadedName} (${downloadedEmail})`,
          templateName: 'download_user_template',
          downloadItems: downloadItemsString
        })
      });

      if (!response.ok) {
        throw new Error('Failed to send email notification');
      }
      
      window.dispatchEvent(new CustomEvent('formSubmitted', {
        detail: { email: downloadedEmail }
      }));
      
      handleOpen();
      
    } catch (error) {
      console.error('Form submission error:', error);
      alert(error);
    } finally {
      setIsProcessing(false);
      setDownloadedEmail("");
      setDownloadedName("");
    }
  };

  return (
    <Dialog open={open} handler={handleOpen}>
      <Card className="mx-auto w-full ">
      <form onSubmit={saveToLocalStorage}>
          <CardBody className="flex flex-col gap-4">
            <Typography variant="h4" color="blue-gray font-heading">
              Please enter your details
            </Typography>
            <Typography
              className="mb-3 font-normal"
              variant="paragraph"
              color="gray"
            >
              To download the requested files please enter your contact details.
            </Typography>
            <Typography className="-mb-2" variant="h6 font-heading">
              Your Name
            </Typography>
            <Input 
              id="name"
              label="Name" 
              size="lg"
              value={downloadedName}
              onChange={e => setDownloadedName(e.target.value)}
              disabled={isProcessing}
            />
            <Typography className="-mb-2" variant="h6 font-heading">
              Your Email
            </Typography>
            <Input
                size="lg"
                placeholder="name@mail.com"
                id="email"
                label="Email"
                value={downloadedEmail}
                onChange={e => setDownloadedEmail(e.target.value)}
                disabled={isProcessing}
              />       
          </CardBody>
          <CardFooter className="pt-0">
            <Button variant="gradient" type="submit" fullWidth disabled={isProcessing}>
              {isProcessing ? (
                <div className="flex items-center justify-center gap-2">
                  <Spinner className="h-4 w-4" />
                  Submitting...
                </div>
              ) : (
                "Submit"
              )}
            </Button>            
          </CardFooter>
          </form>
        </Card>

      </Dialog>      
  )
  
}